/**
 * @GENERATED from Figma node 3638:52266
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const KeynoteDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#3BA0F3"
      fillRule="evenodd"
      d="M13.9 10.765a.667.667 0 0 1-.666-.667V1.604c0-.344.282-.627.624-.605a9.79 9.79 0 0 1 9.143 9.16.58.58 0 0 1-.588.606zm-3.722-7.32c.334-.01.61.257.61.59v8.51c0 .368.298.666.666.666h8.5a.6.6 0 0 1 .6.619c-.32 5.116-4.57 9.167-9.766 9.167-5.405 0-9.786-4.381-9.786-9.786 0-5.2 4.056-9.452 9.176-9.767"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(KeynoteDark);
export { ForwardRef as KeynoteDark };
